import { createRouter, createWebHistory } from 'vue-router'
import BarbershopEntryView from '../views/BarbershopEntryView.vue'
import BarbershopInquiryView from '../views/BarbershopInquiryView.vue'
import LoginView from '@/views/LoginView.vue';
import DashboardView from '@/views/DashboardView.vue';
import BarbershopRegisterView from '../views/BarbershopRegisterView.vue'
import SuperAdminView from '../views/admin/SuperAdminView.vue'; // ✅ 경로 주의


const routes = [
  { path: '/', name: 'Entry', component: BarbershopEntryView },
  { path: '/inquiry', name: 'BarbershopInquiry', component: BarbershopInquiryView },
  { path: '/login', name: 'Login', component: LoginView }, // ✅ 여기가 핵심
  { path: '/dashboard', name: 'Dashboard', component: DashboardView, meta: { requiresAuth: true } },
  { path: '/register', name: 'BarbershopRegister', component: BarbershopRegisterView },
  { path: '/detail/:id', name: 'ShopDetailView', component: () => import('../views/ShopDetailView.vue'),props: true},
  { path: '/shop/:id/reservations', name: 'ShopReservationList', component: () => import('../views/ReservationListView.vue') },
  {
    path: '/superadmin',
    name: 'SuperAdmin',
    component: SuperAdminView,
    meta: { requiresAuth: true, requiresAdmin: true }, // ✅ 접근 제어
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('../views/PrivacyPolicyView.vue')
  },
  // ✅ 이거 추가!
{
  path: '/terms',
  name: 'Terms',
  component: () => import('../views/TermsView.vue')
},
  {
  path: '/edit-barbershop/:id',
  name: 'EditBarbershop',
  component: () => import('../views/EditBarbershopView.vue')
} ,
// 상단 import는 lazy loading으로
{
  path: '/shop/:id/settlement',
  name: 'Settlement',
  component: () => import('../views/SettlementView.vue')
}
]

const router = createRouter({
  history: createWebHistory(),
  routes
})


// ✅ 여기에 추가하세요!
router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem('user');
  const kakaoId = JSON.parse(localStorage.getItem('user'))?.kakaoId;

  // 로그인 체크
  if (to.meta.requiresAuth && !isLoggedIn) {
    localStorage.setItem('redirectAfterLogin', to.fullPath);
    return next('/login');
  }

  // 관리자 체크
  if (to.meta.requiresAdmin && kakaoId !== 4250089077) {
    alert('총괄 관리자만 접근 가능합니다.');
    return next('/');
  }

  next();
});

export default router
